<script>
import { fandomBasicMixin, fandomExtendedMixin } from "src/modules/fandom_mixins_module.js";
import { hfarmCorporateTileMixin } from "../../modules/hfarm_corporate_mixins_module.js";
import { get } from 'lodash';

export default {
  mixins: [fandomBasicMixin, fandomExtendedMixin, hfarmCorporateTileMixin],
  computed: {
    icon() {
      return get(this.getDecorator(this.content, "label"), ['icon'], this.content.icon) || "fas fa-file-alt"; 
    }
  },
  methods: {
    getTarget(field) {
      return get(field, "new_tab", false) ? "_blank" : "_self";
    },
    stripHtml(html) {
      let tmp = document.createElement("DIV");
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || "";
    }
  }
}
</script>

<template>
  <div
    v-easyadmin="easyadminId" 
    :class="contentType"
    class="h-100"
  >
    <a
      :target="getTarget(content.url)"
      :href="tileUrl"
      tile-component
    >
      <div class="card h-100" :class="{'card-thumbnail-full': content.thumbnail_full}" :style="{'background-image': content.thumbnail_full ? image : '', 'background-color': content.background_color}">
        <div v-if="!content.thumbnail_full" :style="{'background-image': image}" class="position-relative bg-cover-center ar-16by9"></div>
        <div v-else class="ar-16by9"></div>
        <div v-if="content.thumbnail_full" class="overlay"></div>
        <div class="card-body p-3 tile__text-section">
          <component class="card-title" v-if="content.title" :class="content.title_class" :is="content.title_tag || 'h4'" :style="{'color': content.text_color}">
            {{content.title}}
          </component>
          <component class="card-text" v-if="content.description" :is="content.description_tag || 'p'" :class="content.description_class" :style="{'color': `${content.text_color}`}">{{stripHtml(content.description)}}</component>
        </div>
      </div>
    </a>
  </div>
</template>

<style lang="scss" scoped>
[tile-component] {
  transition: all .25s;

  .card {
    background-color: $gray-100;
    color: $dark !important;
    border: none;
    border-radius: 0;

    &-thumbnail-full {
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;

      .overlay {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgba(0,0,0,.25);
      }
    }

    &-body {
      z-index: 1;
    }

    &-text, &-title {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }

    &-title {
      -webkit-line-clamp: 2;
    }
  }

  .tile__icon {
    width: 4rem;
  }

  h3, ::v-deep p {
    margin-bottom: 0 !important;
  }
}
</style>


